import { createContext } from 'react';
import { ISupportLanguage } from 'utils/types/storyTypes';

const SupportLangContext = createContext<ISupportLanguage[]>([
  { code: 'KO', code_name: '한국어' },
  { code: 'EN', code_name: 'English' },
  { code: 'JA', code_name: '日本語' },
  { code: 'AR', code_name: 'العربية' },
]);

export default SupportLangContext;
